import React from 'react';
import { View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';

export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
}

/**
 * Confirmação em modal — Alert.alert é no-op no react-native-web, então
 * qualquer confirmação client-facing (web-mobile incluso) tem que passar
 * por aqui, nunca por Alert direto.
 */
export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Voltar',
  destructive,
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-4 rounded-2xl" style={{ borderCurve: 'continuous' }}>
        <ThemedText className="text-lg font-bold text-neutral-900">{title}</ThemedText>
        <ThemedText className="text-sm text-neutral-600">{message}</ThemedText>
        <View className="flex-row flex-wrap gap-2">
          <Button
            title={cancelLabel}
            variant="outline"
            className="grow basis-32"
            onPress={() => onOpenChange(false)}
          />
          <Button
            title={confirmLabel}
            variant={destructive ? 'destructive' : 'primary'}
            className="grow basis-32"
            onPress={() => {
              onOpenChange(false);
              onConfirm();
            }}
          />
        </View>
      </DialogContent>
    </Dialog>
  );
}
